import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Popover,
  OverlayTrigger
} from 'react-bootstrap';


class PopoverOfForm extends Component {
  render() {
    return (
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement="right"
        shouldUpdatePosition={true}
        overlay={<Popover id='popover-of-form'>{this.props.children}</Popover>}>
        <span className="ir-tooltip"></span>
      </OverlayTrigger>
    )
  }
}

PopoverOfForm.defaultProps = {
  children: null,
};

PopoverOfForm.propTypes = {
  children: PropTypes.any
  //   .oneOfType([
  //   PropTypes.array,
  //   PropTypes.element,
  // ]),
};


export default PopoverOfForm;



// WEBPACK FOOTER //
// ./src/components/search/FormElements/PopoverOfForm/PopoverOfForm.js